import { useLocation } from 'react-router-dom';

const useSearchParams = () => {
  const location = useLocation();
  const slicedUrl = location.search.slice(1);
  const urlSearchParams = new URLSearchParams(slicedUrl);
  const params = Object.fromEntries(urlSearchParams.entries());
  const email = urlSearchParams.get('email') || '';

  return {
    ...params,
    email,
  };
};

export default useSearchParams;
